module.exports = __webpack_public_path__ + "static/media/CalendarError.987995a1.png";